import React from 'react'

import { TextUnderline } from '../common/Icons'

import CtaButton from './CtaButton'
const GrowBusiness = () => {
  return (
    <div className="container flex flex-col justify-center py-24">
      <h3 className=" text-center text-[clamp(18px,3.8961038961vw,24px)] font-normal leading-125 tracking-lg text-night-black sm:tracking-3xl">
        Looking for a &nbsp;
        <span className="relative whitespace-nowrap font-bold">
          <TextUnderline className=" absolute -bottom-0.5 left-0 w-full " />
          faster, easier
        </span>
        &nbsp; way to grow your business?
      </h3>
      <div className="mx-auto my-6">
        <CtaButton
          title="Get early access"
          url="https://get.day.ai/get-early-access/"
          className="mx-auto"
        />
      </div>
      <p className="common-pera">
        Join the waitlist to receive early access to Day.ai
      </p>
    </div>
  )
}

export default GrowBusiness
